/**
 * Canonical spray-job status values shared by the frontend. Mirrors
 * the SprayJob::STATUS_* constants on the backend. Use this map
 * instead of inlining the strings so a backend value rename can't
 * silently break frontend gating.
 */
export const SPRAY_JOB_STATUS = Object.freeze({
  TO_BE_STARTED: 'to_be_started',
  PREPARED: 'prepared',
  SPRAYING: 'spraying',
  SPRAY_CLEANUP: 'spray_cleanup',
  WAITING_FOR_COMPLETION: 'waiting_for_completion',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
});

export const sprayJobStates = [
  {
    label: 'To Be Started',
    value: 'to_be_started',
    color: 'rgb(85, 159, 47)',
    tagColor: 'gold',
    action: 'Prepare Spray',
  },
  {
    label: 'Prepared',
    value: 'prepared',
    color: 'rgb(239, 203, 25)',
    tagColor: 'blue',
    action: 'Start Spraying',
  },
  {
    label: 'Spraying',
    value: 'spraying',
    color: 'rgb(245, 160, 27)',
    tagColor: 'orange',
    action: 'Cleanup',
  },
  {
    label: 'Spray Cleanup',
    value: 'spray_cleanup',
    color: 'rgb(245, 160, 27)',
    tagColor: 'purple',
    action: 'Finish Job',
  },
  {
    label: 'Waiting for Completion',
    value: 'waiting_for_completion',
    color: 'rgb(245, 160, 27)',
    tagColor: 'orange',
    action: null,
  },
  {
    label: 'Completed',
    value: 'completed',
    color: 'rgb(85, 159, 47)',
    tagColor: 'green',
    action: null,
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
    color: 'rgb(226, 78, 76)',
    tagColor: 'red',
    action: null,
  },
];

/**
 * Get status label by value
 * @param {string} value - e.g. 'completed'
 * @returns {string} - e.g. 'Completed'
 */
export const getSprayJobStatusLabel = (value) => {
  const state = sprayJobStates.find(s => s.value === value);
  return state ? state.label : value;
};

/**
 * Get tag color by status value
 * @param {string} value - e.g. 'completed'
 * @returns {string} - e.g. 'green'
 */
export const getSprayJobTagColor = (value) => {
  const state = sprayJobStates.find(s => s.value === value);
  return state ? state.tagColor : 'default';
};

/**
 * Pause-modal reason values. Must stay in sync with the backend
 * `actionPauseUnplannedRefill` branch in SprayJobController.php.
 */
export const SPRAY_PAUSE_REASON = Object.freeze({
  PAUSE: 'pause',
  UNPLANNED_REFILL: 'unplanned_refill',
});
